import React from 'react'
import { Link } from 'react-router-dom'

type Props = { replace?: boolean, linkTo?: string, label: string, icon: React.ReactElement, iconClassName?: string, linkColor?: string, size?: 'sm' | 'lg' }
const LinkWithIcon: React.FC<Props> = ({ replace, linkTo = '', label, icon, iconClassName, linkColor = 'black', size = 'sm' }) => {
  const linkSize = size === 'sm' ? 'text-xs sm:text-sm' : 'font-semibold text-sm sm:text-base'

  const content = <>{label}<span className='mt-0.5'>{React.cloneElement(icon, { className: `ml-2 w-5 fill-deep-green ${iconClassName}` })}</span></>
  const classNames = `inline-flex items-center text-[${linkColor}] ${linkSize}`
  return (
    <div>
      {linkTo ? (
        <Link to={linkTo} className={classNames} replace={replace}>{content}</Link>
      ) : (
        <div className={classNames}>{content}</div> // sometimes we want to display the label without a link to use onClick handlers
      )}
    </div>
  )
}

export default LinkWithIcon
